import React from "react"
import { Icon } from "antd"
import MenuList from "./components/MenuList"
import Cache from "../../util/cache"
import "./index.less"
import VisitorFlow from "./components/VisitorFlow"
import VisitorCount from "./components/VisitorCount"
import UserProfile from "./components/UserProfile"
import UserAssets from "./components/UserAssets"
import ShopAnalysis from "./components/ShopAnalysis"
import WishList from "./components/WishList"
import ShopActive from "./components/ShopActive"
import ShopRelated from "./components/ShopRelated"
const menu = {
  flow: { name: "客流趋势", className: "flow", com: VisitorFlow },
  visitor: { name: "到访分析", className: "visitor", com: VisitorCount },
  base: { name: "基础画像", className: "base", com: UserProfile },
  "shop-analysis": {
    name: "店铺排行",
    className: "shop-analysis",
    com: ShopAnalysis,
  },
  "wish-list": { name: "购买意愿", className: "wish-list", com: WishList },
  "shop-active": {
    name: "店铺动线",
    className: "shop-active",
    com: ShopActive,
  },
  "shop-related": {
    name: "店铺相关",
    className: "shop-related",
    com: ShopRelated,
  },
  asset: {
    name: "经济画像",
    className: "asset",
    com: UserAssets,
  },
}
export default class Shop extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    let { id, name, floor, date, single, onCloseModal } = nextProps
    let currentMenu = Cache.getSessionStorage("shop_menu") || "flow"
    let ml = [
      "flow",
      "visitor",
      "base",
      "shop-analysis",
      "wish-list",
      "shop-active",
      "shop-related",
    ]
    if (single) {
      // currentMenu = "flow"
      ml = ["flow", "visitor", "base", "asset"]
    }
    if (!ml.includes(currentMenu)) {
      currentMenu = "flow"
    }
    currentMenu = menu[currentMenu] || menu["flow"]
    if (id !== prevState.id) {
      return {
        id,
        name,
        floor,
        date,
        single,
        onCloseModal,
        currentMenu,
        menuList: ml.map(m => {
          return menu[m]
        }),
      }
    }
    return null
  }
  constructor(props) {
    super(props)

    this.state = {}
  }

  changeMenu(m) {
    Cache.setSessionStorage("shop_menu", m.className)
    this.setState({ currentMenu: m })
  }

  renderBody() {
    let { id, floor, date } = this.state
    let menu = this.state.currentMenu
    let Comp = menu.com
    if (Comp) {
      return <Comp id={id} floor={floor} date={date} />
    }
  }

  render() {
    let { onCloseModal, name } = this.state
    let { menuList } = this.state
    return (
      <div className="page page-shop">
        <div className="page-inner">
          <div className="header">
            <Icon type="left" onClick={onCloseModal} />
            <div>{name}</div>
          </div>
          <div className="content">
            <MenuList
              list={menuList}
              onChangeMenu={m => {
                this.changeMenu(m)
              }}
              current={this.state.currentMenu}
            />
            <div className="shop-body">{this.renderBody()}</div>
          </div>
        </div>
      </div>
    )
  }
}
